module.exports = {
  OperationFailed: '操作失败',
  SelectTime: '选择时间',
  FeeRefund: '（有费用退关）',
  TheHasExpiredNoCreated: '该委托单位合同到期，不能再创建业务',
  DueCannotBePrintedNeeded: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  ItPrintedPleaseContactUnlock: '已被锁定,不能打印,请联系上级主管解锁!',
  AttachmentContentIsTooLarge: '附件内容过大',
  Unknown: '不详',
  YourWeightAndVolumeTo: '您的货物已参与过数据对比，自动装箱将会更新本票和所在主票的件毛体信息。',
  Tip: '提示',
  GotIt: '知道了',
  AddNew: '新增',
  PleaseSelectTheSpecifiedData: '请选择指定数据',
  LicenseOfLadingNumberEmpty: '车牌号和提单号不能为空',
  IntegratedLogisticsCargoDetails: '综合物流货物明细',
  PleaseAPieceOfData: '请选择一条数据！',
  Mbl: 'CMR号'
}
